export default class PropertyAttribute {
    constructor({ name = "", label = "", value = true }) {
      this.name = name;
      this.label = label;
      this.value = value;
    }
  }